import { useEffect, useState } from 'react';
import { getError } from '../utils/error-helpers/getError';
import { isStringsPropOk } from '../utils/stringUtils';
const StringsPropVerification = ({
  children,
  componentName,
  isProductionEnv,
  logger,
  strings,
  stringsKeys
}) => {
  const [prodError, setProdError] = useState(false);
  useEffect(() => {
    try {
      isStringsPropOk(stringsKeys, strings, componentName);
    } catch (error) {
      if (isProductionEnv) {
        setProdError(true);
        logger.logError(getError(error));
      } else {
        setProdError(false);
        throw error;
      }
    }
  }, [strings, componentName, logger, stringsKeys, isProductionEnv]);
  return prodError ? null : children;
};
export default StringsPropVerification;